import axios from "../../../../api/axios";

export const addMRQVendor = async (mrqVendor) => {
    const addMRQVendorApi = `/mrq/addMRQVendor`;
    console.log("data: ", mrqVendor)
    const { data } = await axios.post(addMRQVendorApi, mrqVendor);
    return data;
}